<template>

  <div>
    <div class="form-group">
      <label>{{ $t('Name') }}</label>
      <input v-autofocus type="text" class="form-control" v-model="scoreform.name">
      <ValidateMessage :error="validateErrors.name" />
    </div>

    <h6>{{ $t('Interview Type') }}</h6>
    <div
      class="form-group"
      v-if="resourceAvailability.features.includes('voice_interview')">
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="conventional"
          value="conventional"
          v-model="scoreform.interview_type">
        <label
          class="form-check-label"
          for="conventional">
          {{ $t('Conventional') }}
        </label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="voice-interview"
          value="voice-interview"
          v-model="scoreform.interview_type">
        <label
          class="form-check-label"
          for="voice-interview">
          {{ $t('Voice AI Interview') }}
        </label>
      </div>
    </div>
    
    <div v-if="scoreform.interview_type === 'voice-interview'">
      <h6>{{ $t('Voice Interview Settings') }}</h6>
      <ScoreformVoiceInterviewForm
        v-model="scoreform.voice_interview" />
    </div>

    <h6>{{ $t('Scorecard Settings') }}</h6>
    <div
      class="list-form"
      v-sortable="{ handle: '.sortable-move', items: scoreform.groups}">
      <div
        class="card"
        v-for="(group, group_index) in scoreform.groups"
        :key="group_index">
        
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <div class="mr-auto"><a href="javascript:void(0)" class="sortable-move text-secondary"><i class="fas fa-arrows-alt" /></a></div>
            <div><a href="javascript:void(0)" class="text-secondary" @click="removeGroup(group_index)"><i class="far fa-trash-alt" /></a></div>
          </div>
        </div>

        <div class="card-body">
          <div class="form-group">
            <input 
              type="text" 
              class="form-control" 
              :placeholder="$t('Group title')" 
              v-model="group.name">
            <ValidateMessage :error="validateErrors['groups.' +group_index+ '.name']" />
          </div>

          <div>
            <ul
              class="form-items"
              v-sortable="{ handle: '.move', items: group.questions}">
              <li
                v-for="(question, question_index) in group.questions"
                :key="question_index">
                <div><a href="javascript:void(0)" class="move text-secondary"><i class="fas fa-arrows-alt" /></a></div>
                <div class="form-items-input">
                  <input
                    type="text"
                    v-model="group.questions[question_index]"
                    :placeholder="$t('Question')">
                  <ValidateMessage :error="validateErrors['groups.' +group_index+ '.questions.' +question_index]" />
                </div>
                <div><a href="javascript:void(0)" class="text-secondary" @click="removeQuestion(group.questions, question_index)"><i class="fas fa-times" /></a></div>
              </li>
            </ul>
            <br>
            <a
              href="javascript:void(0)"
              @click="addQuestion(group.questions)">{{ $t('Add item') }}</a>
          </div>
        </div>

      </div>
    </div>

    <div><a href="javascript:void(0)" @click="addGroup()">{{ $t('Add question') }}</a></div>
  </div>

</template>

<script>
import ScoreformVoiceInterviewForm from './ScoreformVoiceInterviewForm.vue'
export default {
  name: 'ScoreformForm',
  components: {
    ScoreformVoiceInterviewForm
  },
  props: {
    initScoreform: {
      type: Object,
      default: () => ({})
    },
    validateErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      scoreform: this.defaultValues(this.initScoreform)
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    }
  },
  watch: {
    scoreform: {
      handler (newValue) {
        this.$emit('update', newValue)
      },
      deep: true
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        interview_type: 'conventional',
        groups: [],
        voice_interview: {
          questions: []
        }
      }, values)
    },
    addGroup () {
      this.scoreform.groups.push({
        name: '',
        questions: ['']
      })
    },
    removeGroup (index) {
      this.scoreform.groups.splice(index, 1)
    },
    addQuestion (items) {
      items.push('')
    },
    removeQuestion (items, index) {
      items.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Scoreform/ScoreformForm.vue